module.exports = __webpack_public_path__ + "static/media/logRCChannelsActive.0aa26513.svg";